if (!customElements.get("size-chart-modal")) {
  customElements.define(
    "size-chart-modal",
    class SizeChartModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="SizeChartInfo"]');
      }

      hide() {
        this.modalContent.innerHTML = "";
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");
        const sizeChartLink = opener.getAttribute("data-page-url");
        const title = opener.getAttribute("data-product-title");
        const url = "/pages/" + sizeChartLink.replace("size-charts/", "");
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const sizeChart = responseHTML.querySelector("main");

            const header = sizeChart.querySelector("h1");

            if (header && title) {
              header.innerText = title;
            }

            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              sizeChart.outerHTML
            );

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }
    }
  );
}
